module.exports = "//static.hsappstatic.net/LoginUI/static-1.8261/img/chatspot-icon.png"